<!-- ═══════════════ HEADER DEL MODAL (pg-modal-header) ═══════════════ -->
<ion-header class="pg-modal-header ion-no-border">
    <ion-toolbar>
      <ion-buttons slot="start">
        <button class="pg-modal-close-btn" (click)="dismiss()" title="Cerrar">
          <ion-icon name="close-outline"></ion-icon>
        </button>
      </ion-buttons>

      <div class="pg-modal-title-wrap">
        <h1 class="pg-modal-title">{{ title }}</h1>
        <span class="pg-modal-sub" *ngIf="subtitle">{{ subtitle }}</span>
      </div>

      <ion-buttons slot="end">
        <button class="pg-modal-close-btn" (click)="clearFilters()" title="Limpiar todo">
          <ion-icon name="trash-outline"></ion-icon>
        </button>
      </ion-buttons>
    </ion-toolbar>
  </ion-header>

  <!-- ═══════════════ CONTENIDO PRINCIPAL ═══════════════ -->
  <ion-content class="pg-main-content">
    <div class="pg-filter-modal-container">

      <!-- Sección Ordenar Por -->
      <div class="pg-filter-panel" *ngIf="sortOptions.length > 0">
        <div class="pg-panel-header">
          <div class="pg-panel-title-wrap">
            <div class="pg-panel-icon-wrap">
              <ion-icon name="swap-vertical-outline"></ion-icon>
            </div>
            <span class="pg-panel-title">Ordenar por</span>
          </div>
        </div>

        <div class="pg-section-info-box" *ngIf="showSortDescription">
          <ion-icon name="compass-outline"></ion-icon>
          <span>Define la jerarquía y secuencia visual en que se organizarán las tarjetas.</span>
        </div>

        <div class="pg-chips-wrap">
          <button type="button"
                  *ngFor="let s of sortOptions"
                  class="pg-choice-chip"
                  [class.active]="currentSortField === s.field"
                  (click)="setSort(s.field)">
            <span>{{ s.label }}</span>
            <ion-icon *ngIf="currentSortField === s.field"
                      [name]="currentSortDirection === 'asc' ? 'arrow-up-outline' : 'arrow-down-outline'">
            </ion-icon>
          </button>
        </div>
      </div>

      <!-- Sección Modo de Vista (Opcional) -->
      <div class="pg-filter-panel" *ngIf="currentViewMode">
        <div class="pg-panel-header">
          <div class="pg-panel-title-wrap">
            <div class="pg-panel-icon-wrap">
              <ion-icon name="eye-outline"></ion-icon>
            </div>
            <span class="pg-panel-title">Vista</span>
          </div>
        </div>

        <div class="pg-chips-wrap">
          <button type="button"
                  class="pg-choice-chip"
                  [class.active]="selectedViewMode === 'card'"
                  (click)="setViewMode('card')">
            <ion-icon name="albums-outline"></ion-icon>
            <span>Tarjeta</span>
          </button>
          <button type="button"
                  class="pg-choice-chip"
                  [class.active]="selectedViewMode === 'list'"
                  (click)="setViewMode('list')">
            <ion-icon name="list-outline"></ion-icon>
            <span>Lista</span>
          </button>
        </div>
      </div>

      <!-- Secciones Dinámicas de Filtros -->
      <ng-container *ngFor="let group of regularFilters">
        <div class="pg-filter-panel" *ngIf="isGroupVisible(group)">
          <div class="pg-panel-header">
            <div class="pg-panel-title-wrap">
              <div class="pg-panel-icon-wrap">
                <ion-icon [name]="group.icon || 'filter-outline'"></ion-icon>
              </div>
              <span class="pg-panel-title">{{ group.label }}</span>
              <span class="pg-panel-counter" *ngIf="group.selectedValues.length > 0">
                {{ group.selectedValues.length }}
              </span>
            </div>

            <button type="button"
                    class="pg-panel-clear-btn"
                    (click)="clearSection(group)"
                    *ngIf="group.selectedValues.length > 0">
              Limpiar
            </button>
          </div>

          <!-- Opciones del grupo principal (ej. Organizar / Agrupar por) -->
          <div class="pg-chips-wrap">
            <button type="button"
                    *ngFor="let opt of group.options"
                    class="pg-choice-chip"
                    [class.active]="group.selectedValues.includes(opt.value)"
                    [class.disabled]="group.id !== 'especiales' && hasEspecialesActive()"
                    (click)="toggleOption(group, opt.value)">
              <span class="chip-dot"></span>
              <span>{{ opt.label }}</span>
            </button>
          </div>

          <!-- Si es el grupo de agrupación, anidamos los sub-criterios (formatos/regiones) en el mismo card -->
          <div class="pg-nested-divider-block" *ngIf="group.id === 'agrupacion' && subAgrupacionGroups.length > 0">
            <div class="pg-nested-subgroup" *ngFor="let sub of subAgrupacionGroups">
              <div class="pg-nested-header">
                <div class="pg-nested-title-wrap">
                  <ion-icon [name]="sub.icon || 'funnel-outline'"></ion-icon>
                  <span class="pg-nested-title">Filtrar por {{ sub.label }}</span>
                  <span class="pg-nested-counter" *ngIf="sub.selectedValues.length > 0">
                    {{ sub.selectedValues.length }}
                  </span>
                </div>
                <button type="button"
                        class="pg-panel-clear-btn"
                        (click)="clearSection(sub)"
                        *ngIf="sub.selectedValues.length > 0">
                  Limpiar
                </button>
              </div>

              <div class="pg-chips-wrap">
                <button type="button"
                        *ngFor="let opt of sub.options"
                        class="pg-choice-chip"
                        [class.active]="sub.selectedValues.includes(opt.value)"
                        (click)="toggleOption(sub, opt.value)">
                  <span class="chip-dot"></span>
                  <span>{{ opt.label }}</span>
                </button>
              </div>
            </div>
          </div>

        </div>
      </ng-container>

    </div>
  </ion-content>

  <!-- ═══════════════ FOOTER DE ACCIONES ═══════════════ -->
  <ion-footer class="pg-modal-footer ion-no-border">
    <div class="pg-footer-actions">
      <button type="button" class="pg-btn-clear-all" (click)="clearFilters()">
        <ion-icon name="trash-outline"></ion-icon>
        <span>Limpiar todo</span>
      </button>
      <button type="button" class="pg-btn-apply" (click)="apply()">
        <ion-icon name="checkmark-circle-outline"></ion-icon>
        <span>Aplicar Filtros</span>
      </button>
    </div>
  </ion-footer>
